import { createSlice } from "@reduxjs/toolkit";

const initialAgentsUnderAdminListingState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  meta: {},
  entities: null,
  listingForEdit: undefined,
  lastError: null,
  queryParams: {},
  filters: {},
};
export const AgentUnderAdminCallTypes = {
  list: "list",
  action: "action",
};

export const agentUnderAdminFollowupSlice = createSlice({
  name: "agentUnderAdminFollowupSlice",
  initialState: { ...initialAgentsUnderAdminListingState },
  extraReducers: (builder) => {
    builder.addCase("[Auth] Logout Action", (state, action) => {
      return { ...initialAgentsUnderAdminListingState };
    });
  },
  reducers: {
    reset: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.totalCount = 0;
      state.entities = null;
      state.listingForEdit = undefined;
      state.lastError = null;
      state.queryParams = {};
      state.filters = {};
    },
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === AgentUnderAdminCallTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === AgentUnderAdminCallTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getListingById
    listingFetched: (state, action) => {
      state.actionsLoading = false;
      state.listingForEdit = action.payload.listingForEdit;
      state.error = null;
    },
    // agent Under Admin Followups Fetched
    agentUnderAdminFollowupsFetched: (state, action) => {
      var { meta, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.meta = meta;
      state.entities = entities;
      state.totalCount = meta.total_count;
      //alert(JSON.stringify(action.payload['queryParams']))
      if (action.payload["queryParams"]) {
        state.queryParams = action.payload["queryParams"];
      }
    },
    setFilters: (state, action) => {
      state.listLoading = false;

      //alert(JSON.stringify(action.payload['queryParams']))
      if (action.payload["filters"]) {
        state.filters = { ...action.payload["filters"] };
      }
    },
  },
});
